import * as yup from 'yup';
import { EditModalFormData } from './types';

export const validationSchema = yup.object<EditModalFormData>({
  mnemonic: yup.string().required('Обязательное поле.'),
  translation: yup.string().required('Обязательное поле.'),
});
